import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { API_URL } from './../../constants/server';
import Search from 'react-search'
import axios from 'axios';

class Ping extends Component {

  constructor(props) {
    super(props)
    this.state = { repos: [] }
  }

  HiItems(items) {
    console.log(items)
  }

  componentWillMount() {
    this.setState({ message: '' });
  }

  ping() {
    axios.get(`${API_URL}/public`)
      .then(response => this.setState({ message: response.data.message }))
      .catch(error => this.setState({ message: error.message }));
  }

  securedPing() {
    const { getAccessToken } = this.props.auth;
    const headers = { 'Authorization': `Bearer ${getAccessToken()}`}
    axios.get(`${API_URL}/searchads`, { headers })
      .then(response => this.setState({ message: JSON.parse(response.data.message) }))
      .catch(error => this.setState({ message: error.message }));
  }

  getItemsAsync(searchValue, cb) {

    const { getAccessToken } = this.props.auth;
    const headers = { 'Authorization': `Bearer ${getAccessToken()}`}
    axios.get(`${API_URL}/searchads/search/apps`, { params: { searchValue: searchValue}, headers })
      .then(response => {
        if(response.data != undefined){
          let itemData = JSON.parse(response.data).data;
          console.log(itemData );
          let items = itemData.map( (res, i) => { return { id: i, value: res.appName + ' ---- ' + res.developerName } })
          console.log( ' items ' , items );
          
          this.setState({ repos: items })
          cb(searchValue)
        }
      // this.setState({ message: JSON.parse(response.data.message) })
      })
      .catch(error => this.setState({ message: error.message }));  

  }

  render() {
    const { isAuthenticated } = this.props.auth;
    const { message } = this.state;
    return (
      <div className="container">
        <h1>Make a Call to the Server</h1>
        {
          !isAuthenticated() &&
            <p>Log in to call a private (secured) server endpoint.</p>
        }
        <Button bsStyle="primary" onClick={this.ping.bind(this)}>Ping</Button>
        {' '}
        {
          isAuthenticated() && (
              <Button bsStyle="primary" onClick={this.securedPing.bind(this)}>
                Call Private
              </Button>
            )
        }
        <h2>{ message}</h2>

        <div>
          <Search items={this.state.repos}
                  multiple={false}
                  getItemsAsync={this.getItemsAsync.bind(this)}
                  onItemsChanged={this.HiItems.bind(this)} />
        </div>
      </div>
    );
  }
}

export default Ping;



// WEBPACK FOOTER //
// ./src/containers/Ping/Ping.js